import React, {StrictMode, useState,useMemo} from 'react';
import ReactDom from "react-dom/client";
import './styles/index.css';
import {NumberFormat,SelectField} from "../../../Components/FE/HtmlField";
import useFormField from "../../../Common/hooks/useFormField";
import {Const} from "../../../Common/const";
import {formatFPN, parseNumberSeparator,NumberFormatAllowUtils} from "../../../Common/utils";
import {isNullOrWhiteSpace} from "../../../Common/app";

const listFuel = data.listFuel;
const listFuelUnitToe = data.listFuelUnitToe;
const listGroupFuel = data.listGroupFuel;
const listTarget = ["TOE"];

const IndexComponent = () => {
    const [selectedFuel,setSelectedFuel] = useState(null)
    const [selectedFuelUnitId,setSelectedFuelUnitId] = useState(null);
    const [toeInput,setToeInput] = useState("");
    const [selectedTarget,setSelectedTarget] = useState(null);
    const [result,setResult] = useState(null);
    const [prefixResultString,setPrefixResultString] = useState("Kết quả:");
    
    const setFuelUnitToe = useMemo(() => {
        return Array.from(
            new Map(listFuelUnitToe.map(item => [item.fuelOrGroupId, item])).values()
        );
    },[listFuelUnitToe]);
    
    const fuelFieldOptions = setFuelUnitToe.map((fuelToe) => {
        let label = "";
        let index = 0;
        if(fuelToe.type === Const.fuelUnitToe.fuel){
            const fuel = listFuel.find(fuel => fuel.id === fuelToe.fuelOrGroupId);
            label = fuel?.fuelName;
            index = fuelToe.id
        }
        else if(fuelToe.type === Const.fuelUnitToe.groupFuel){
            const groupFuel = listGroupFuel.find(group => group.id === fuelToe.fuelOrGroupId);
            label = groupFuel.title;
            index = fuelToe.id
        }
        return {
            value: index,
            label: label
        }
    });
    const fuelUnitOptions = listFuelUnitToe.filter(fuelToe => fuelToe.fuelOrGroupId === selectedFuel?.fuelOrGroupId).map(fuelToe => ({value: fuelToe.id,label: fuelToe.unit}));
    const targetOptions = listTarget.map((target,idx) => ({value: idx,label: target}));
    
    const selectedFuelValue = fuelFieldOptions.find(option => option.value === selectedFuel?.id);
    const selectedFuelUnitIdValue = fuelUnitOptions.find(option => option.value === selectedFuelUnitId);
    const targetValue = targetOptions.find(option => option.value === selectedTarget);
    const handleConvert = () => {
        if(selectedFuel === null || isNullOrWhiteSpace(toeInput) || selectedTarget === null || selectedFuelUnitId === null){
            if(selectedFuel === null){
                toastr.error("Vui lòng chọn dạng năng lượng");    
            }
            if(isNullOrWhiteSpace(toeInput)){
                toastr.error("Vui lòng nhập giá trị cần quy đổi");
            }
            if(selectedTarget === null){
                toastr.error("Vui lòng chọn đơn vị quy đổi");
            }
            if(selectedFuelUnitId === null){
                toastr.error("Vui lòng chọn đơn vị nguồn");
            }
        }
        else{
            const selectedFuelToe = listFuelUnitToe.find(fuel => fuel.id === selectedFuelUnitId);
            setPrefixResultString(`Kết quả: ${toeInput} (${selectedFuelToe.unit}) = `)
            setResult(formatFPN(parseNumberSeparator(toeInput) * selectedFuelToe.toe));
        }
    }
    const handleReset = () => {
        setSelectedFuel(null);
        setSelectedFuelUnitId(null);
        setSelectedTarget(null);
        setResult(null);
        setToeInput("")
        setPrefixResultString("Kết quả:");
    }
    const handleSelectFuelField = (selected) => {
        const selectedFuel = listFuelUnitToe.find(f => f.id === selected.value);
        setSelectedFuel(selectedFuel);
        setSelectedFuelUnitId(null);
    }
    const handleToeChange = (e) => {
        setToeInput(e.target.value);
    }
    
    const handleSelectFuelUnit = (selected => {
        setSelectedFuelUnitId(selected.value);
    });
    const handleSelectTarget =(selected) => {
        setSelectedTarget(selected.value);
    }
    return(
        <div className="container convert-tool">
            <div className={"row row-gap-3 mb-3"}>
                <div className={"col-12"}>
                    <div className={"input-group"}>
                        <span
                            className={"input-group-text"}>
                            Danh mục
                        </span>
                        <SelectField
                            styles={{
                                control: (provided) => ({
                                    ...provided,
                                    border: 'none',
                                    boxShadow: 'none',
                                    borderRadius: 0,
                                    '&:hover': {
                                        border: 'none',
                                    },
                                })
                            }}
                            options={fuelFieldOptions}
                            value={selectedFuelValue ?? ""}
                            className={"form-control list-select"}
                            handleChange={handleSelectFuelField}/>
                    </div>
                </div>
                <div className={"col-12"}>
                    <div className={"input-group"}>
                       <span
                           className={"input-group-text"}>
                           Giá trị
                       </span>
                        <NumberFormat
                            value={toeInput}
                            onChange={handleToeChange}
                            name={"toeInput"}
                            className={"toe-input"}
                            isAllowed={NumberFormatAllowUtils.greaterOrEqualZero}
                        />
                    </div>
                </div>
                <div className={"col-sm-6"}>
                    <div className={"input-group"}>
                        <span className={"input-group-text"}>Từ</span>
                        <SelectField
                            styles={{
                                control: (provided) => ({
                                    ...provided,
                                    border: 'none',
                                    boxShadow: 'none',
                                    borderRadius: 0,
                                    '&:hover': {
                                        border: 'none',
                                    },
                                })
                            }}
                            options={fuelUnitOptions}
                            value={selectedFuelUnitIdValue ?? ""}
                            className={"form-control list-select"}
                            handleChange={handleSelectFuelUnit}/>
                    </div>
                </div>
                <div className={"col-sm-6"}>
                    <div className={"input-group"}>
                        <span className={"input-group-text"}>Quy đổi sang</span>
                        <SelectField
                            styles={{
                                control: (provided) => ({
                                    ...provided,
                                    border: 'none',
                                    boxShadow: 'none',
                                    borderRadius: 0,
                                    '&:hover': {
                                        border: 'none',
                                    },
                                })
                            }}
                            options={targetOptions}
                            value={targetValue ?? ""}
                            className={"form-control list-select"}
                            handleChange={handleSelectTarget}/>
                    </div>
                </div>
            </div>
            <div className={"mb-4"}>
                <button className={"btn-primary btn btn-reset me-2"} onClick={handleReset}>
                    Đặt lại
                </button>
                <button className={"btn-success btn btn-convert"} onClick={handleConvert}>
                    Chuyển đổi
                </button>
            </div>
            <div className={"result-wrapper mgb-12"}>
                <span>
                    {prefixResultString}
                    <span className={"result"}>
                        {
                            `${result ? result + ` ${listTarget[selectedTarget]}` : ""}`
                        }
                    </span>
                </span>
            </div>
            <span className={"section-text-note text-center"}>
                Công thức quy đổi tham khảo bởi công văn số 3505/BCT-KHCN, 19/04/2011
            </span>
        </div>
    );
}
const root = ReactDom.createRoot(document.getElementById('section-convert-tool'));
root.render(
    <StrictMode>
        <IndexComponent />
    </StrictMode>
);